import script from "./DataChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DataChangeModal.vue?vue&type=script&setup=true&lang=js"

import "./DataChangeModal.vue?vue&type=style&index=0&id=40212dc1&lang=css"

const __exports__ = script;

export default __exports__